// extracted by mini-css-extract-plugin
export var aggregationCell = "_52-k";
export var aggregationRow = "_52-j";
export var borderlessSpinnerContainer = "_52-3";
export var closeIcon = "_52-c";
export var columnHeaderSurface = "_52-8";
export var columnHeaderSurfaceDragOverlay = "_52-s";
export var columnHeaderSurfaceResizing = "_52-p";
export var contextMenuAnchor = "_52-1";
export var draggableColumnHeader = "_52-q";
export var draggableColumnHeaderOverlay = "_52-r";
export var expandIcon = "_52-d";
export var expanded = "_52-e";
export var filterDropdown = "_52-f";
export var filterDropdownDivider = "_52-a";
export var filterDropdownHeader = "_52-i";
export var filterDropdownItem = "_52-h";
export var filterDropdownModal = "_52-g _52-f";
export var filterItem = "_52-9";
export var normalCellWithAdjustableBorder = "_52-b";
export var pinButtonContainer = "_52-l";
export var pinIcon = "_52-m";
export var pinIconActive = "_52-n";
export var spinner = "_52-0";
export var spinnerContainer = "_52-2";
export var tableContainer = "_52-4";
export var tableContentDraggingColumns = "_52-7";
export var tableContentInner = "_52-6";
export var tableContentWrapper = "_52-5";
export var viewButtonContainer = "_52-o";